"use client"
import { APIProvider } from "@vis.gl/react-google-maps"
import { Attribute } from "api"
import { LocationProvider } from "contexts/LocationProvider"
import { LocatorMapType, MapTypeProvider } from "contexts/MapLocatorTypeProvider"
import { ReactNode, Suspense } from "react"

const mapKey = process.env.GOOGLE_API_KEY as string

type Props = {
  metadata: Attribute[]
  defaultFilterIds?: number[] | null
  children: ReactNode
  appType: LocatorMapType
}

export default function LocatorLayout({ metadata, defaultFilterIds, children, appType }: Props) {
  return (
    <MapTypeProvider initialMapType={appType}>
      <LocationProvider metadata={metadata} defaultFilterIds={defaultFilterIds}>
        <Suspense>
          <APIProvider apiKey={mapKey} language="iw">
            {children}
          </APIProvider>
        </Suspense>
      </LocationProvider>
    </MapTypeProvider>
  )
}
